import config from './config'
import { handleResponse } from './handle-response'
import { checkToken, authHeader } from './helpers'

export const productsService = {
	list,
}

async function list(search = null, retries = 3, delay = 1000) {
	await checkToken()
	const requestOptions = { method: 'GET', headers: authHeader() }

	const url = new URL(`${config.apiUrl}/product/`)
	if (search) {
		url.searchParams.append("search", search)
	}

	try {
		const resp = await fetch(url.toString(), requestOptions)
		return handleResponse(resp)
	} catch (err) {
		if (retries > 0) {
			await new Promise(res => setTimeout(res, delay))
			return list(retries - 1, delay)
		}
		throw err
	}
}


// async function listByReportNumber() {

//     await checkToken()

//     const requestOptions = { method: 'GET', headers: authHeader()}
//     return fetch(`${config.apiUrl}/plans-by-reports/`, requestOptions)
//         .then(handleResponse)
//         .then(user => {
//             return user
//         })
// }

// async function listTransactions(urlParams = '') {
// 	await checkToken();
	
// 	const requestOptions = { method: 'GET', headers: authHeader() };
// 	return fetch(`${config.apiUrl}/transaction/${urlParams}`, requestOptions)
// 	  .then(handleResponse)
// 	  .then(data => {
// 		return data;
// 	  });
//   }

//   async function listWallet(urlParams = '') {
// 	await checkToken();
	
// 	const requestOptions = { method: 'GET', headers: authHeader() };
// 	return fetch(`${config.apiUrl}/wallet/${urlParams}`, requestOptions)
// 	  .then(handleResponse)
// 	  .then(data => {
// 		return data;
// 	  });
// }